import React from 'react';
import { SubmitButton, ButtonSize } from 'ui-builder';
import UpdateProjectForm from '../launch/CreateUpdateProject/UpdateProjectForm';

import styles from './UpdateProjectForm.module.scss';
import TextButton from '../history/RecordLayout/TextButton';
import useLaunchProjectNavigator from '../launch/launchProjectNavigator';
import useFeatureToggleService from 'feature-toggle';

interface Props {
  projectId: number,
}

function OpenUpdateProjectPageButton() {
  const launchNavigator = useLaunchProjectNavigator();
  return (
    <TextButton
      text="Edit Launch"
      onClick={() => launchNavigator.openUpdateProjectPage()}
      testId="edit-launch-button"
    />
  );
}

export default function Form(props: Props) {
  const featureToggleService = useFeatureToggleService();
  const isNewUpdateTransactionFormEnabled = featureToggleService.isNewUpdateTransactionFormEnabled();

  return (
    <UpdateProjectForm
      title="Transaction Setup"
      projectId={props.projectId}
      buttons={(
        <>
          <SubmitButton text="Update" size={ButtonSize.MEDIUM} />
          {!isNewUpdateTransactionFormEnabled && <OpenUpdateProjectPageButton />}
        </>
      )}
      checkDateUpdates
      className={styles.detailsUpdateForm}
    />
  );
}
